import React from "react";

import { useQuery } from "@apollo/client";

import * as _ from "lodash";

// @ts-ignore
import { Theme, useTheme } from "@material-ui/core/styles";

import useMediaQuery from "@material-ui/core/useMediaQuery";

// import '../../node_modules/leaflet/dist/leaflet.css';

import NodeMap from "../components/node-map2";

import useWindowSize from "../use-window-size";

import { loader } from "graphql.macro";

// const GetAllDeviceNodes = loader('../graphql/GetAllDeviceNodes.graphql');
const GetAllNodes = loader("../graphql/GetAllNodes.graphql");

interface Props {}

function MapPage(props: Props) {
  const theme = useTheme() as Theme;
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [windowWidth, windowHeight] = useWindowSize();
  // TODO suspend true when react bug fixed
  const { data, error, loading } = useQuery(GetAllNodes, {
    // suspend: false
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error);
    return <p>Error :(</p>;
  }

  const nodes = data.nodes;

  // TODO cf. panel-select!
  function flattened(node: any): any[] {
    if (!node.children) {
      return [];
    }
    return [node, ..._.flatMap(node.children, (n) => flattened(n))];
  }
  const mapNode = (node: any) => {
    // const id = `${node.id}`;
    return {
      ...node,
      name: node.displayName,
      children: node.children ? node.children.map((n: any) => mapNode(n)) : [],
    };
  };

  // TODO is nodes not an array?
  const mapped =
    nodes &&
    flattened([nodes].map((node: any) => mapNode(node))[0]).filter(
      (node: any) => node.nodeClassName === "DEVICE"
    );
  // console.log("nodes", nodes);
  // console.log("mapped", mapped);

  return (
    <div style={{ width: "100%", height: windowHeight - (mobile ? 120 : 220) }}>
      <NodeMap nodes={mapped} />
    </div>
  );
}

export default MapPage;
